import get from 'lodash/get'
import { determinations } from 'app/utils/subscription'

export class MarketingConcern {
  constructor(account, subscription) {
    this.account = account
    this.subscription = subscription
    this.determinations = determinations({
      subscription: get(this, 'subscription'),
      isBacker: get(this, ['account', 'isBacker'], false)
    })
  }

  get showAdvertising() {
    return !this.determinations.exists || !this.determinations.active || this.determinations.isFree
  }

  get hasActiveProSubscription() {
    return this.determinations.exists && this.determinations.active && this.determinations.isPro
  }
}
